import { Route } from '@angular/router';

/** Administration, access control, onboarding, invoice numbering. */
export const administrationChildren: Route[] = [
  {
    path: 'example',
    loadChildren: () => import('app/modules/administration/admin/example/example.routes'),
  },
  {
    path: 'admin',
    loadChildren: () => import('app/modules/administration/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'administration',
    loadChildren: () => import('app/modules/administration/admin/admin.routes').then((m) => m.adminRoutes),
  },
  {
    path: 'on-boarding',
    loadChildren: () =>
      import('app/modules/administration/on-boarding/on-boarding.module').then((m) => m.OnBoardingModule),
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('app/modules/administration/access-control/roles/roles.routes').then((m) => m.ROLES_ROUTES),
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('app/modules/administration/access-control/user-management/user-management.routes').then(
        (m) => m.USER_MANAGEMENT_ROUTES,
      ),
  },
  {
    path: 'access-control',
    loadComponent: () =>
      import('app/modules/administration/access-control/access-control-wrapper.component').then(
        (m) => m.AccessControlWrapperComponent,
      ),
    children: [
      {
        path: 'login-history',
        loadComponent: () =>
          import('app/modules/administration/access-control/login-history/login-history-list.component').then(
            (m) => m.LoginHistoryListComponent,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login-history',
      },
    ],
  },
  {
    path: 'permissions-management',
    loadChildren: () =>
      import(
        'app/modules/administration/admin/access-control/permission-tree-structure/permission-tree-structure-routing.module'
      ).then((m) => m.PermissionTreeStructureRoutingModule),
  },
  {
    path: 'role-management',
    loadChildren: () =>
      import(
        'app/modules/administration/admin/access-control/role-management/role-management-routing.module'
      ).then((m) => m.roleManagementRoutes),
  },
  {
    path: 'invoice-numbering',
    loadChildren: () =>
      import('app/modules/administration/invoice-numbering/invoice-numbering.module').then(
        (m) => m.InvoiceNumberingModule,
      ),
  },
  {
    path: 'einvoice',
    loadChildren: () =>
      import('app/modules/administration/admin/einvoice/einvoice.module').then(
        (m) => m.EinvoiceModule,
      ),
    data: { permission: 'administration.e-invoice' },
  },
];
